import { LogoDiv } from "./style";
import Logo from "../../assets/img/Logo.svg";
import Bag from "../../assets/img/Bag.svg";
import Balls from "../../assets/img/Balls.svg";
import { StyledText } from "../../style/typography";

export const LogoContent = () => {
  return (
    <LogoDiv>
      <img src={Logo} alt="Burguer Kenzie" />
      <div>
        <div>
          <img src={Bag} alt="" />
        </div>
        <div>
          <StyledText tag="headline" textStyle="default" color="#828282">
            A vida é como um sanduíche, é preciso recheá-la com os{" "}
            <span>melhores</span> ingredientes.
          </StyledText>
        </div>
      </div>
      <img src={Balls} alt="" />
    </LogoDiv>
  );
};
